import PropTypes from 'prop-types'
import { memo } from 'react'
import Divider from 'components/core/Divider/Divider'
import styles from './Spacer.module.scss'

/**
 * The `Spacer`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Spacer (props) {
  const { divider } = props

  return (
    <div className={styles.spacer}>
      {divider && <Divider />}
      <span />
    </div>
  )
}

Spacer.propTypes = {
  divider: PropTypes.bool
}

Spacer.defaultProps = {
  divider: false
}

export default memo(Spacer)
